// górna belka mobilnego headera (Wise) - Język + Wyloguj/Zaloguj

import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { BoxArrowRight, BoxArrowInRight } from 'react-bootstrap-icons';
import classnames from 'classnames';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

import { useAppNavigate } from 'hooks';
import {
  useGetLayoutLanguages,
  usePostOverLogout,
  useGetLayoutUrlResolverToLanguage
} from 'api';
import { useDispatch, reduxActions, useSelector } from 'store';
import { DropDown } from 'components/controls';

import { ReactComponent as FlagPL } from 'assets/flags/pl.svg';
import { ReactComponent as FlagEN } from 'assets/flags/gb.svg';

import styles from 'theme/components/wise/WiseHeaderTopBar/WiseHeaderTopBar.module.scss';

const WiseHeaderTopBar = () => {
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();
  const { profile, overloginUserId } = useSelector((state) => state.auth);
  const { pathname, search } = useLocation();
  const navigate = useAppNavigate();

  const { data: languagesData } = useGetLayoutLanguages();

  const { mutateAsync: refetchUrlResolverToLanguage } = useGetLayoutUrlResolverToLanguage({
    onSuccess: (data) => {
      const params = {
        ...qs.parse(search),
        ...qs.parse(data.parameters)
      };
      navigate(`/${data.url_shortcut}?${qs.stringify(params)}`, { replace: true });
    }
  });

  const { mutateAsync } = usePostOverLogout();

  const handleLogout = async () => {
    if (overloginUserId) {
      await mutateAsync();

      if (pathname.includes('/cart/')) {
        navigate('/cart/0');
      }

      dispatch(reduxActions.setCurrentCartId(null));
      dispatch(reduxActions.setOverlogin(null));

      return;
    }
    dispatch(reduxActions.signOut());
  };

  const flags: Record<string, ReactElement> = {
    en: <FlagEN />,
    pl: <FlagPL />
  };

  const handleChangeLanguage = async (id: string) => {
    const getPosition = (string: string, subString: string, index: number) =>
      string.split(subString, index).join(subString).length;
    const urlPrefix = pathname.slice(0, getPosition(pathname, '/', 2)).replace('/', '');
    const urlKey = pathname.replace(urlPrefix, '').replaceAll('/', '');

    try {
      await refetchUrlResolverToLanguage({ urlKey, fromLanguage: urlPrefix, toLanguage: id });
      i18n.changeLanguage(id);
    } catch (err) {
      i18n.changeLanguage(id);
    }
  };

  if (!profile) {
    return null;
  }

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Components-Wise-WiseHeaderTopBar'
      )}>
      <DropDown
        label={
          <span className={styles.language}>
            {flags[i18n.language]}
            {t('Język')}
          </span>
        }
        items={
          languagesData?.items.map((lang) => ({
            label: (
              <span className={styles.language}>
                {flags[lang.id]}
                {lang.name}
              </span>
            ),
            onClick: () => handleChangeLanguage(lang.id)
          })) || []
        }
        withDropdownIcon={false}
      />

      {profile?.role !== 'ROLE_OPEN_PROFILE' ? (
        <button className={styles.authButton} onClick={handleLogout}>
          {overloginUserId ? t('Wróć na konto') : t('Wyloguj')} <BoxArrowRight />
        </button>
      ) : (
        <button
          className={styles.authButton}
          onClick={() => navigate(`/login?return_url=${encodeURIComponent(pathname)}`)}>
          {t('Zaloguj')} <BoxArrowInRight />
        </button>
      )}
    </div>
  );
};

export default WiseHeaderTopBar;
